<template>
    <div>
        <div class="uk-padding">
            <div class="uk-container uk-container-small">
                <div class="">
                    <h1 class=" uk-heading-line uk-text-center  specHeading">
                        Contact Us
                    </h1>
                    <div class="uk-alert-primary" uk-alert>
                        <a class="uk-alert-close" uk-close></a>
                        <p class="uk-text-center">
                            <!-- We invite you to visit us anytime to <router-link to="/arrangevisit">schedule a visit</router-link>.
                             <br>-->
                            Please use our <router-link to="/searchDepartment" style="color: black" class=" uk-text-bold">Department Directory</router-link> to find the department you wish to contact.
                        </p>
                    </div>

                   <!-- <hr class="uk-divider-icon">-->
                    <div class="">
                        <div class="uk-container uk-container-large@m uk-container-small@l">

                            <br>
                            <div  uk-grid>
                                <div class="uk-align-center uk-text-center">
                                    <!--<p class="uk-text-center">Find Us | Like Us</p>-->
                                    <div >
                                        <a href="https://twitter.com/ncueducation" target="_blank" class="uk-icon-button uk-margin-small-right" uk-icon="twitter" style="color: #00aced;"></a>

                                        <a href="https://www.facebook.com/ncueducation/" target="_blank" class="uk-icon-button  uk-margin-small-right" uk-icon="facebook" style="color: #3b5998;"></a>

                                        <a href="https://plus.google.com/106251138258617752932" target="_blank" class="uk-icon-button" uk-icon="google-plus" style="color: #dd4b39;"></a>

                                        <a href="https://www.instagram.com/ncu_jamaica/" target="_blank" class="uk-icon-button uk-margin-small-right" uk-icon="instagram" style="color: #3b5998;"></a>

                                        <a href="https://www.flickr.com/photos/72113266@N04/" target="_blank" class="uk-icon-button  uk-margin-small-right" uk-icon="flickr" style="color: #ff0084;"></a>

                                        <a href="https://jm.linkedin.com/school/northern-caribbean-university/" target="_blank" class="uk-icon-button" uk-icon="linkedin" style="color: #007bb6;"></a>

                                        <a href="https://www.youtube.com/channel/UCaAlpTlb1Qk-S-UVGKtijKg" target="_blank" class="uk-icon-button" uk-icon="youtube" style="color: #bb0000;"></a>
                                    </div>
                                </div>

                                <div class="uk-width-1-1@s uk-width-1-1@m">
                                    <h3 class="uk-heading-bullet uk-text-left specHeading">Main Campus</h3>
                                    <div uk-grid>
                                        <div class="uk-width-1-3@m">

                                            <div uk-grid>
                                                <div class="uk-width-1-1">
                                                    <br>
                                                </div>
                                                <div class="uk-width-1-3@s uk-visible@s">

                                                    <p class="specHeading" style="color: #033860">Address: </p>
                                                </div>
                                                <div class="uk-width-2-3@s">
                                                    <p class="">
                                                        Northern Caribbean University
                                                        Manchester Rd. <br>

                                                        Mandeville <br>
                                                        Manchester <br>
                                                        Jamaica <br>
                                                        West Indies
                                                    </p>
                                                </div>
                                            </div>
                                            <div uk-grid>
                                                <div class="uk-width-1-3@s uk-visible@s">
                                                    <p class="specHeading" style="color: #033860">Telephone: </p>
                                                </div>
                                                <div class="uk-width-2-3@s">
                                                    <p class="">
                                                        1-876-618-1652  <br>
                                                        1-876-963-7000/7400 <br>
                                                        <!-- 1-888-429-5628 (Toll Free) <br>-->
                                                        1-876-962-0075 (Fax) <br>
                                                    </p>
                                                </div>
                                            </div>
                                            <div uk-grid>
                                                <div class="uk-width-1-3@s uk-visible@s">
                                                    <p class="specHeading" style="color: #033860">Email: </p>
                                                </div>
                                                <div class="uk-width-2-3@s">
                                                    <p class="">
                                                        info@ncu.edu.jm  <br>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="uk-width-2-3@m">
                                            <div class="uk-align-center">
                                                <iframe
                                                        src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d2641.3304412664593!2d-77.49895195118414!3d18.01482157562484!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2sjm!4v1525362833547"
                                                        width="100%" height="450" frameborder="0" style="border:0" allowfullscreen>

                                                </iframe>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <br><br>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="uk-padding uk-background-muted">
            <div class="uk-container uk-container-large@m uk-container-small@l">
                <div uk-grid>
                    <div class="uk-width-1-1@s uk-width-1-1@m">
                        <h3 class="uk-heading-bullet uk-text-left specHeading">East Jamaica Regional Campus (Kingston)</h3>
                        <div uk-grid>

                            <div class="uk-width-2-3@m">
                                <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2405.14218788556!2d-76.79538246125932!3d18.00515684333053!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8edb3fbaf5cdc2bb%3A0xb047dfa7b0075ffd!2sNorthern+Caribbean+University+-+Kingston+Campus!5e1!3m2!1sen!2sjm!4v1525362909146"
                                        width="100%" height="450" frameborder="0" style="border:0" allowfullscreen>

                                </iframe>
                            </div>
                            <div class="uk-width-1-3@m">
                                <div uk-grid>
                                    <div class="uk-width-1-1 uk-visible@s">
                                        <br>
                                    </div>
                                    <div class="uk-width-1-3@s uk-visible@s">
                                        <p class="specHeading" style="color: #033860">Address: </p>
                                    </div>
                                    <div class="uk-width-2-3@s">
                                        <p class="">
                                            Northern Caribbean University <br>
                                            Kingston Campus, <br>
                                            Half Way Tree Road,
                                            <br> Kingston <br>
                                            Jamaica <br>
                                            West Indies
                                        </p>
                                    </div>
                                </div>
                                <div uk-grid>
                                    <div class="uk-width-1-3@s uk-visible@s">
                                        <p class="specHeading" style="color: #033860">Telephone: </p>
                                    </div>
                                    <div class="uk-width-2-3@s">
                                        <p class="">
                                            1876-963-7057 <br> 1-876-963-7062 <br> 1-876-963-7066


                                        </p>
                                    </div>
                                </div>
                                <div uk-grid>
                                    <div class="uk-width-1-3@s uk-visible@s">
                                        <p class="specHeading" style="color: #033860">Email: </p>
                                    </div>
                                    <div class="uk-width-2-3@s">
                                        <p class="">
                                            kingstoncampus@ncu.edu.jm  <br>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <br><br>
            </div>
        </div>
        <div class="uk-padding">
            <div class="uk-container uk-container-large@m uk-container-small@l">
                <div uk-grid>
                    <div class="uk-width-1-1@s uk-width-1-1@m">
                        <h3 class="uk-heading-bullet uk-text-left specHeading">West Jamaica Regional Campus (Montego Bay)</h3>
                        <div uk-grid>


                            <div class="uk-width-1-3@m">

                                <div uk-grid>
                                    <div class="uk-width-1-1 uk-visible@s">
                                        <br>
                                    </div>
                                    <div class="uk-width-1-3@s uk-visible@s">
                                        <p class="specHeading" style="color: #033860">Address: </p>
                                    </div>
                                    <div class="uk-width-2-3@s">
                                        <p class="">
                                            Northern Caribbean University, <br>
                                            Montego Bay, <br>
                                            Western Campus, <br>
                                            Montego Bay <br>
                                            Jamaica <br>
                                            West Indies
                                        </p>
                                    </div>
                                </div>
                                <div uk-grid>
                                    <div class="uk-width-1-3@s uk-visible@s">
                                        <p class="specHeading" style="color: #033860">Telephone: </p>
                                    </div>
                                    <div class="uk-width-2-3@s">
                                        <p class="">
                                            1-876-963-7031-5 <br>
                                            1-876-963-7041 ( Fax )
                                        </p>
                                    </div>
                                </div>
                                <div uk-grid>
                                    <div class="uk-width-1-3@s uk-visible@s">
                                        <p class="specHeading" style="color: #033860">Email: </p>
                                    </div>
                                    <div class="uk-width-2-3@s">
                                        <p class="">
                                            info@ncu.edu.jm  <br>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="uk-width-2-3@m">
                                <div class="uk-align-center">
                                    <iframe
                                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3376.3139842620576!2d-77.91265238243847!3d18.470630531483952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8eda2a63e22d68a7%3A0xd9a047e8124fd91c!2sNorthern+Caribbean+University+Montego+Bay%2C+Western+Campus!5e1!3m2!1sen!2sjm!4v1525363663727"
                                            width="100%" height="450" frameborder="0" style="border:0" allowfullscreen>

                                    </iframe>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <br><br>
            </div>
        </div>

        <div class="uk-padding uk-background-muted">
            <div class="uk-container uk-container-large@m uk-container-small@l">
                <div uk-grid>
                    <div class="uk-width-1-1@s uk-width-1-1@m">
                        <h3 class="uk-heading-bullet uk-text-left specHeading">North Jamaica Regional Campus (St. Ann's Bay)</h3>
                        <div uk-grid>

                            <div class="uk-width-2-3@m">

                                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d1307.0608515446074!2d-77.19582552822499!3d18.433148167737638!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2sjm!4v1554762380541!5m2!1sen!2sjm"
                                        width="100%" height="450"
                                        frameborder="0" style="border:0"
                                        allowfullscreen></iframe>
                            </div>
                            <div class="uk-width-1-3@m">
                                <div uk-grid>
                                    <div class="uk-width-1-1 uk-visible@s">
                                        <br>
                                    </div>
                                    <div class="uk-width-1-3@s uk-visible@s">
                                        <p class="specHeading" style="color: #033860">Address: </p>
                                    </div>
                                    <div class="uk-width-2-3@s">
                                        <p class="">
                                            Northern Caribbean University <br>
                                            Suite 14-15, <br>
                                            4 Gloucester Drive ,
                                            Windsor Estate, <br>
                                            St. Ann's bay, <br>
                                            St. Ann, <br>
                                            Jamaica, West Indies
                                        </p>
                                    </div>
                                </div>
                                <div uk-grid>
                                    <div class="uk-width-1-3@s uk-visible@s">
                                        <p class="specHeading" style="color: #033860">Telephone: </p>
                                    </div>
                                    <div class="uk-width-2-3@s">
                                        <p class="">
                                            1-876-963-7046-9 <br>

                                            1-876-973-5671 (Fax) <br>

                                            1-876-963-7250-5 ( Admissions )
                                        </p>
                                    </div>
                                </div>
                                <div uk-grid>
                                    <div class="uk-width-1-3@s uk-visible@s">
                                        <p class="specHeading" style="color: #033860">Email: </p>
                                    </div>
                                    <div class="uk-width-2-3@s">
                                        <p class="">
                                            salem-campus@ncu.edu.jm <br>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <br><br>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ContactUs"
    }
</script>

<style scoped>

</style>